import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bluearrows",
  "use": "icon-bluearrows-usage",
  "viewBox": "0 0 15 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 13\" id=\"icon-bluearrows\">\r\n  <defs>\r\n    <style>\r\n      #icon-bluearrows .cls-1 {\r\n        fill: #40a9ff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-bluearrows_蓝箭头\" class=\"cls-1\" d=\"M729.01,409.994l2.684-6.494-2.684-6.494,14.98,6.494Z\" transform=\"translate(-729 -397)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bluearrows.svg
// module id = QT1r
// module chunks = 127